import { deferUntilNewTitle } from '@moda/portal-stanchions';
import {
  ProductDetailsFragment,
  ProductDetailsVariantFragment,
  SizeInventoryFragment,
  User
} from '../generated/types';
import { tc } from '../lib/trackingContext';
import { getVariantClickHistory } from '../lib/variantClicksHistory';

export interface TrackProductViewedParams {
  variant: ProductDetailsFragment;
  activeVariant: ProductDetailsVariantFragment;
  selectedSize: SizeInventoryFragment | null;
  badgeMessage: string | null;
  user: User;
}

export const trackProductViewed = ({
  variant,
  activeVariant,
  selectedSize,
  badgeMessage,
  user
}: TrackProductViewedParams) => {
  // update the tracking context immediately
  tc.setCurrent('variant', variant);

  // wait until title (and URL) have updated in DOM
  deferUntilNewTitle(() => {
    const history = getVariantClickHistory(activeVariant.id);

    tc.track('Product Viewed', {
      addToScopeOnce: { activeVariant, user },
      addToTrackingEvent: {
        size: selectedSize,
        badge: badgeMessage,
        label: activeVariant.id,
        category: [variant.category[0]?.toString(), variant.subcategory[0]?.toString()].join('/'),
        index: variant.index,
        eventType: 'view',
        queryID: history?.queryId ?? null,
        objectID: variant.objectid,
        position: history?.position ?? null,
        tag: variant.tag
      }
    });
  });
};
